import Vue from 'vue'
import * as VueDeepSet from 'vue-deepset'
Vue.use(VueDeepSet)
